import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { API_BASE_URL } from '../config/api.config';
import { TeamSection } from '../models/team-section.model';

// Secciones de equipo que devuelve el backend (el servicio ya las cachea). Se piden una vez por
// carga de la app y se comparten entre el header, /fixture y /squad. La lista llega ya ordenada
// por displayOrder: si viene vacía o falla, no hay secciones que mostrar.
@Injectable({ providedIn: 'root' })
export class TeamSectionsService {
  private readonly http = inject(HttpClient);
  private readonly state = signal<TeamSection[]>([]);
  private readonly loadStatus = signal<'loading' | 'ready' | 'error'>('loading');
  readonly sections = this.state.asReadonly();
  // 'error' = falló la llamada (distinto de una lista vacía).
  readonly status = this.loadStatus.asReadonly();

  constructor() {
    this.load();
  }

  // Reintento manual; no hay reintentos automáticos.
  reload(): void {
    this.load();
  }

  private load(): void {
    this.loadStatus.set('loading');
    this.http.get<TeamSection[]>(`${API_BASE_URL}/content/team-sections`).subscribe({
      next: (items) => {
        this.state.set(Array.isArray(items) ? items : []);
        this.loadStatus.set('ready');
      },
      error: () => {
        this.state.set([]);
        this.loadStatus.set('error');
      },
    });
  }
}
